// utils/celularColombiano.js — validación/normalización de celular colombiano (T2).
// ESPEJO de la lógica del backend (utils/posCustomerMatch.normalizePhone +
// esCelularColombiano): no comparten runtime (patrón colTime). Si una cambia, la
// otra también.
//
// Un celular colombiano válido normaliza a 10 dígitos que empiezan por 3. Al
// escribir se aceptan +57, espacios, guiones y paréntesis (se limpian acá).

export function normalizarCelular(raw) {
  let d = String(raw == null ? '' : raw).replace(/\D/g, '');
  if (d.length > 10 && d.startsWith('57')) d = d.slice(2); // +57 / 57 de Colombia
  return d;
}

export function esCelularColombiano(raw) {
  const d = normalizarCelular(raw);
  return d.length === 10 && d.startsWith('3');
}

// Correo válido solo si se escribió algo (opcional): un vacío es válido (no obliga).
export function esCorreoValido(raw) {
  const e = String(raw == null ? '' : raw).trim();
  if (!e) return true; // opcional: vacío no es error
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}
